import React from "react";
import vtLogo from "../Assets/Images/vt-purple-logo.png";
const GrievanceRedressal = () => {
  return (
    <>
      {" "}
      <>
        <div className="container">
          <div className="row">
            <div className="col-12 my-2">
              <img
                className="img-fluid mt-4 mb-1"
                src={vtLogo}
                style={{ margin: "auto", display: "block", width: "180px" }}
                alt="Vidyuttech logo"
              />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12 mb-5">
              <h1 className="text-center">Grievance Redressal Policy</h1>

              <h2 className="text-center mt-5">
                Grievance Redressal Mechanism of Vidyut Green Labs
              </h2>

              <p className="fw-bold">1. Objective and Scope of the Policy</p>

              <p>
                At Vidyuttech, we are committed to providing the highest level
                of service to our customers. However, we recognize that there
                may be instances where our services do not meet customer
                expectations. This Grievance Redressal Policy is established to
                ensure that all complaints from customers are addressed
                promptly, transparently, and in a fair manner.
              </p>

              <p>
                This policy applies to all grievances related to our services,
                including loan applications, processing, disbursement, and other
                support provided by Vidyuttech in collaboration with our banking
                and NBFC partners.
              </p>

              <p className="fw-bold">
                2. Procedure for Grievance Redressal Mechanism
              </p>

              <p>
                Customers can raise their grievances by sending an email to{" "}
                <a href="mailto:gro@vidyuttech.com">gro@vidyuttech.com</a> with
                the following details:
              </p>

              <ul>
                <li>Full Name</li>
                <li>Contact Information (Phone Number and Email ID)</li>
                <li>Loan Account Number (if applicable) or PAN Number </li>
                <li>Detailed description of the issue or complaint</li>
              </ul>

              <p className="fw-bold">3. Grievance Acknowledgment</p>

              <p>
                Upon receipt of the grievance, we will send an{" "}
                <strong>acknowledgment within 5 business days</strong>. This
                acknowledgment will confirm that the complaint has been received
                and is being reviewed.{" "}
              </p>

              <p className="fw-bold">4. Resolution Process</p>

              <ul>
                <li>
                  Investigation: The grievance will be thoroughly investigated
                  to identify the cause of the issue. Vidyuttech may reach out
                  to you for further details if needed.{" "}
                </li>
                <li>
                  Resolution Timeline: We strive to{" "}
                  <strong>
                    resolve all complaints within 15 business days from the date
                    of receipt
                  </strong>
                  . If the resolution is expected to take longer, we will inform
                  you of the anticipated time for resolution.{" "}
                </li>
                <li>
                  Communication of Resolution: Once a resolution is reached, our
                  team will communicate the outcome of the investigation and the
                  steps taken to address the issue via email.
                </li>
              </ul>

              <p className="fw-bold">5. Escalation Matrix</p>

              <p>
                If a complaint is not resolved to your satisfaction, you may
                escalate the matter by replying to the email you received or
                contacting{" "}
                <a href="mailto:escalations@vidyuttech.com">
                  escalations@vidyuttech.com
                </a>
                .{" "}
                <strong>
                  Escalated grievances will be addressed on a priority basis and
                  resolved within 10 business days from the date of escalation
                </strong>
                .
              </p>

              <table className="table table-striped">
                <thead>
                  <tr>
                    <td>S.No</td>
                    <td>Turn Around Time</td>
                    <td>Name and Designation</td>
                    <td>Contact Details</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>15 Business Days</td>
                    <td>
                      Gaurav Srivastava
                      <br />
                      MD and GRO
                    </td>
                    <td>
                      Address:
                      <br />
                      2nd Floor, 2nd Building, Hustlehub Techpark
                      <br />
                      27th Main Road End, HSR Layout Sector 1<br />
                      Bangalore, Karnataka, India - 560102
                      <br />
                      Email:{" "}
                      <a href="mailto:gro@vidyuttech.com">gro@vidyuttech.com</a>
                      <br />
                      Phone: +91-702-702-4496
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>10 Business Days</td>
                    <td>
                      Xitij Kothi
                      <br />
                      Managing Director
                    </td>
                    <td>
                      Address:
                      <br />
                      2nd Floor, 2nd Building, Hustlehub Techpark
                      <br />
                      27th Main Road End, HSR Layout Sector 1<br />
                      Bangalore, Karnataka, India - 560102
                      <br />
                      Email:{" "}
                      <a href="mailto:escalations@vidyuttech.com">
                        escalations@vidyuttech.com
                      </a>
                      <br />
                      Phone: +91-702-702-4496
                    </td>
                  </tr>
                </tbody>
              </table>

              <p className="fw-bold">6. Procedure for Consent Withdrawal</p>
              <p>
                Withdrawal of consent will prevent Vidyuttech from accessing the
                corresponding customer's credit bureau data. The consent to
                access credit bureau data expires automatically within 180 days.
                If a customer explicity want to withdraw consent then they can
                do so by filling the form by clicking here:{" "}
                <a
                  target="_blank"
                  href="https://www.vidyuttech.com/withdraw-consent/"
                >
                  Click here to open consent withdrawal form
                </a>
              </p>

              <p className="fw-bold">
                7. Adoption, Review, Feedback and Continuous Improvement
              </p>

              <p>
                At Vidyuttech, we conduct annual review of the grievance
                resolution process and cases in order to continuously improve
                our services based on the insights we gain.
              </p>

              <p>
                Vidyuttech values your feedback. You can send your feedback to{" "}
                <a href="mailto:contactus@vidyuttech.com">
                  contactus@vidyuttech.com
                </a>{" "}
              </p>
              <p className="fw-bold">
                8. External Links:
              </p>

              <p>
                For any complaints or grievances regarding Shivalik Bank services, please refer to their{" "}
                <a href="https://shivalik.bank.in/assets/upload/uploads/Grievances-Redressals-Mechanisms-Businesss-Correspondents-Englishs.pdf" target="_blank" >
                  (Official Grievance Redressal Mechanism)
                </a>{" "}
              </p>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default GrievanceRedressal;
